import styled from "@emotion/styled";


export const Wrapper = styled.div<{ contrast: boolean, iconBack: string, midPos?: boolean}>`
    background: ${props => props.iconBack};
    width:30px;
    height:30px;
    border-radius:50%;
    border:1px solid ${props => props.theme.colors.mainTextColor};
    box-shadow:0 0 2px 0 rgba(0,0,0,0.25);

    position:absolute;
    bottom: ${props => props.midPos? "35%" :"4px"};
    right:4px;
    padding:7px;


    svg{
        path{
            fill: ${props => props.contrast? props.theme.colors.mainTextColor: props.theme.colors.white} ;
        }
    }
`;